export { default, getStaticPathsWithoutCountry as getStaticPaths, getStaticProps } from '../[countryCode]/category/[categoryPath]';